<template>
    <div>
        <b-alert
            :show="alertShow"
            variant="danger"
        >
            <b-icon icon="info-circle" class="mr-2"></b-icon>
            <span v-html="message"></span>
        </b-alert>
    </div>
</template>

<script>
export default {
    props: {
        user: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            message: null,
            alertShow: false,
        };
    },
    watch: {
        user: {
            immediate: true,
            handler(newValue) {
                this.messages(newValue);
            }
        },
    },
    methods: {
        messages(user) {
            const locale = this.$store.getters.getLocale;
            if (locale == 'en') {
                this.message = user.student_information_messages.en;
            } else {
                this.message = user.student_information_messages.tr;
            }
            this.alertShow = !!this.message;
        }
    }
};
</script>
